import { type MotionValue } from 'motion/react'
import { type ReactNode } from 'react'
import {
  StickyViewHeader,
  StickyViewHeaderMain,
} from '@/components/StickyViewHeader'

export interface BookkeepingManagerHeaderProps {
  scrollOffset: MotionValue<number>
  children?: ReactNode
}

export function BookkeepingManagerHeader({
  scrollOffset,
  children,
}: BookkeepingManagerHeaderProps) {
  return (
    <StickyViewHeader scrollOffset={scrollOffset}>
      <StickyViewHeaderMain>{children}</StickyViewHeaderMain>
    </StickyViewHeader>
  )
}
